<template>
   <QBtn
      id="7days"
      color="primary"
      size="sm"
      outline
      class="date-shortcut"
      @click="handle7Days"
      >7 Day</QBtn
   >
   <QBtn
      id="14days"
      color="primary"
      size="sm"
      outline
      class="date-shortcut"
      @click="handle14Days"
      >14 Day</QBtn
   >
   <QBtn
      id="30days"
      color="primary"
      size="sm"
      outline
      class="date-shortcut"
      @click="handle30Days"
      >30 Day</QBtn
   >
</template>

<script setup lang="ts">
import { QBtn } from "quasar"
import { useAnalyticsStore } from "@stores/analyticsStore"

const emit = defineEmits(["date-shortcut-clicked"])

const analyticsStore = useAnalyticsStore()

const handle7Days = () => {
   // Use local timezone for consistency with manual date picker
   const today = new Date()
   const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)
   const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, 0, 0, 0, 0)

   analyticsStore.updateDateRange(
      Math.floor(startDate.getTime()),
      Math.floor(endDate.getTime()),
   )

   // Emit event for parent component
   emit("date-shortcut-clicked", "7days")
}

const handle14Days = () => {
   // Use local timezone for consistency with manual date picker
   const today = new Date()
   const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)
   const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14, 0, 0, 0, 0)

   analyticsStore.updateDateRange(
      Math.floor(startDate.getTime()),
      Math.floor(endDate.getTime()),
   )

   // Emit event for parent component
   emit("date-shortcut-clicked", "14days")
}

const handle30Days = () => {
   // Use local timezone for consistency with manual date picker
   const today = new Date()
   const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999)
   const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30, 0, 0, 0, 0)

   analyticsStore.updateDateRange(
      Math.floor(startDate.getTime()),
      Math.floor(endDate.getTime()),
   )

   // Emit event for parent component
   emit("date-shortcut-clicked", "30days")
}
</script>
<style scoped lang="scss">
@media (max-width: 1000px) {
   .date-shortcut {
      display: none;
   }
}
</style>
